import {  updateCustomerProduct } from "api/Customers";
import { UseMutationOptions, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useUpdateCustomerProduct = (
options?: UseMutationOptions<any, any, any, unknown>
) => {
    const queryClient = useQueryClient();
    return useMutation(updateCustomerProduct, {
        onSuccess: () => {
            toast.success("Customer Product updated successfully!");
            queryClient.invalidateQueries('customerProducts')
            queryClient.invalidateQueries('coustomers')
            queryClient.invalidateQueries("customerPending");
        },
        onError: (error:any) => {
            if(error.response.data.error_type === 'commission_validation'){
                toast.error(error.response.data.message);
                return
              }
            toast.error("Customer update failed! Please try again later.");
        },
        ...options
    })
}